export interface ENV {
  apiEndPoint: string;
  root: string;
  pageTitle: string;
  tokenKey: string;
  appName: string;
  apiSubscriptionEndPoint: string;
  languageKey: string;
  testDeviceCode: string;
  apiEndPointwS: string;
  piApiEndPoint: string;
  timeToSendInfoToSever: string;
  minutesOfScreen: string;
  timeOfScreenAfterAdminOnScreen: string;
  webrtcSignalingServer: string;
  webrtcStunServer: string;
  webrtcTurnServer: string;
  webrtcTurnUsername: string;
  webrtcTurnCredential: string;
}

const cwd = process.cwd();
const root = __dirname.replace(`${cwd}`, '.');
const env: ENV = {
  apiEndPoint: process.env.REACT_APP_API_END_POINT || '',
  apiEndPointwS: process.env.REACT_APP_API_END_POINT_WS || '',
  apiSubscriptionEndPoint: process.env.REACT_APP_API_SUBSCRIPTION_END_POINT || '',
  root,
  pageTitle: process.env.REACT_APP_PAGE_TITLE || '',
  tokenKey: process.env.REACT_APP_TOKEN_KEY || '',
  appName: process.env.REACT_APP_NAME || '',
  languageKey: process.env.REACT_APP_LANGUAGE_KEY || '',
  testDeviceCode: process.env.REACT_APP_TEST_DEVICE_CODE || '',
  piApiEndPoint: process.env.REACT_APP_PI_API_END_POINT || '',
  timeToSendInfoToSever: process.env.REACT_APP_TIME_TO_SEND_INFO_TO_SERVER || '',
  minutesOfScreen: process.env.REACT_APP_MINUTES_TO_OFF_SCREEN || '',
  timeOfScreenAfterAdminOnScreen: process.env.REACT_APP_TIME_OF_SCREEN_AFTER_ADMIN_ON_SCREEN || '',
  webrtcSignalingServer: process.env.REACT_APP_WEB_RTC_SIGNALING_SERVER || '',
  webrtcStunServer: process.env.REACT_APP_WEB_RTC_STUN_SERVER || '',
  webrtcTurnServer: process.env.REACT_APP_WEB_RTC_TURN_SERVER || '',
  webrtcTurnUsername: process.env.REACT_APP_WEB_RTC_TURN_USER || '',
  webrtcTurnCredential: process.env.REACT_APP_WEB_RTC_TURN_CREDENTIAL || '',
};

export default env;
